import { replaceExpression } from 'modules/widgets/functions/broadcast/send';

const handle = (socket) => {
  socket.on('message.broadcast', (msg, { room, users }, { messages }) => {
    msg.data_d.message = replaceExpression(msg.data_d.message);

    messages.add({
      msg,
      msgType: 'broadcast',
    });
  });
};

export default handle;
